// extracted by mini-css-extract-plugin
export default {"edit-connections-button":"styles_edit-connections-button__+EY2q"};